export default __webpack_public_path__ + "static/media/bar-chart 1.012c3e48.svg";